<template>
  <layout title="Reset Password">
    <div class="flex flex-col justify-center py-20 sm:px-6 lg:px-8">
      <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <h2
          class="mt-6 text-3xl font-extrabold leading-none text-center text-gray-900 lg:text-5xl"
        >
          Setup Your New Password
        </h2>
        <p class="mt-4 text-sm leading-5 text-center text-gray-600 max-w">
          or, return to
          <inertia-link :href="$route('login')" class="link">
            login here
          </inertia-link>
        </p>
      </div>

      <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div
          class="px-4 py-8 bg-white border shadow border-gray-50 sm:rounded-lg sm:px-10"
        >
          <form role="form" @submit.prevent="change" method="POST">
            <div class="mt-6">
              <label
                for="email"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Email Address
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  id="email"
                  type="email"
                  name="email"
                  required
                  class="w-full"
                  v-model="form.email"
                  placeholder="Email Address"
                />
              </div>
              <div class="error" v-if="errors.email">{{ errors.email }}</div>
            </div>

            <div class="mt-6">
              <label
                for="password"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Password
              </label>
              <div class="mt-1 rounded-md shadow-sm relative">
                <input
                  id="password"
                  type="password"
                  name="password"
                  required
                  class="w-full"
                  v-model="form.password"
                />
                <passwordReq inputId="password" @validPass="validPassCheck" />
              </div>
              <password-meter :password="form.password" />
              <div class="error" v-if="errors.password">
                {{ errors.password }}
              </div>
              <div class="error" v-if="showError">
                {{ validPass.message }}
              </div>
            </div>

            <div class="mt-3">
              <label
                for="password_confirmation"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Confirm Password
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  id="password_confirmation"
                  type="password"
                  name="password_confirmation"
                  required
                  class="w-full"
                  v-model="form.password_confirmation"
                />
              </div>
              <div class="error" v-if="errors.password_confirmation">
                {{ errors.password_confirmation }}
              </div>
              <div class="error" v-if="errors.g_recaptcha_token">
                {{ errors.g_recaptcha_token }}
              </div>
            </div>

            <div
              class="flex flex-col items-center justify-center text-sm leading-5"
            >
              <span class="block w-full mt-5 rounded-md shadow-sm">
                <button type="submit" class="btn-primary w-full">
                  Reset Password
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>

    <modal :show="showCaptchaModal" @closeModal="closeCaptchaModal">
      <div class="text-center mb-5">
        <h3 class="text-xl font-extrabold text-primary-color">Security Verification</h3>
        <p class="mt-1 text text-gray-500">Please complete the challenge to continue.</p>
      </div>
      <div ref="wafCaptcha" class="flex justify-center"></div>
    </modal>
  </layout>
</template>

<script>
import passwordMeter from "vue-simple-password-meter";
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");
const passwordReq = () =>
  import(/* webpackChunkName: "passwordReq" */ "../Components/passwordReq.vue");
import { wafInertiaPost } from "../utils/waf";
import Modal from "../Components/modal.vue";
export default {
  components: { layout, passwordReq, passwordMeter, Modal },
  props: {
    errors: Object,
  },
  data() {
    return {
      form: {
        token: this.$route().params.token,
        email: null,
        password: null,
        password_confirmation: null,
        g_recaptcha_token: null,
      },
      validPass: {
        value: false,
        message: "",
      },
      showError: false,
      showCaptchaModal: false,
      siteKey: process.env.MIX_RECAPTCHA_SITE_KEY,
    };
  },
  methods: {
    change() {
      if (!this.validPass.value) {
        this.showError = true;
        return;
      }
      this.showError = false;
      this.getRecaptchaToken();
    },
    async submit() {
      await wafInertiaPost(this.$inertia, "/password/reset", this.form, {
        preserveScroll: true,
        onSuccess: () => {
          this.showCaptchaModal = false;
        },
        onError: () => {
          this.showCaptchaModal = false;
        },
      }, this.$refs.wafCaptcha, () => {
        this.showCaptchaModal = true;
      }, () => {
        this.showCaptchaModal = false;
      });
    },
    getRecaptchaToken() {
      let _this = this;
      if (typeof grecaptcha === 'undefined' || !this.siteKey) {
        this.submit();
        return;
      }
      grecaptcha
        .execute(this.siteKey, {
          action: "password_reset",
        })
        .then(function (token) {
          _this.form.g_recaptcha_token = token;
          _this.submit();
        })
        .catch(function () {
          _this.submit();
        });
    },
    closeCaptchaModal() {
      this.showCaptchaModal = false;
      if (this.$refs.wafCaptcha) this.$refs.wafCaptcha.innerHTML = '';
    },
    validPassCheck(value) {
      this.validPass = value;
    },
  },
};
</script>